///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const IntermodalIcon = ({
  height,
  title = messages.intermodal.defaultMessage,
  fill = "#343434",
  width,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="intermodal-icon">{title}</title>
    <path
      d="M47.9717534 0v2.78622767h-3.4077779V0h-3.4111054v2.78622767h-3.4111053V0h-3.4099962v2.78622767h-3.4116599V0h-3.4105508v2.78622767h-3.4105507V0h-3.4108281v2.78622767h-3.405837V0h-3.410828v2.78622767h-3.4111053V0H7.0481943v2.78622767H3.6395845V0H.22847917v2.78622767H0l3.6395845 2.97480177v-.18676089h3.4086098v2.97457512l3.4122145 2.78622763V5.57426855h3.4111053v8.54861705l4.7728301 3.9036198h2.0438349v1.6722353l2.048826 1.6726885h1.3620021v-3.3449238h3.4105507v3.3449238h3.4105508v-3.3449238h3.4116599v3.3449238h3.4099962v-3.3449238h3.4111053v3.3449238h3.4111054v-3.3449238h3.4077779v3.3449238h3.4105508v-3.3449238h3.4130463v-2.7878142h-3.4130463V5.57426855h3.4130463V2.78622767h-3.4130463V0h-3.4105508zm-3.4105508 15.2384646h3.4105508V5.57426855h-3.4105508v9.66419605zm-6.8194378 0h3.4111053V5.57426855h-3.4111053v9.66419605zm-6.8216561 0h3.4116599V5.57426855h-3.4116599v9.66419605zm-6.8211015 0h3.4102735V5.57426855h-3.4102735v9.66419605zm-6.8216561 0h3.410828V5.57426855h-3.410828v9.66419605z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);

export default IntermodalIcon;
